import { rdxPopupOpen } from "commons/popup/store/popupR";
import { useDispatch } from "react-redux";
import { PopupType } from "../PopupType";
import { useApi } from "store/modules/common";
import type { IAlarmtalkPopUpData } from "./AlarmtalkVo";
import { useSelectorEq } from "commons/store/common";
import type { IState } from "store/modules";
import { useEffect } from "react";
import { apiGPartnerList, rdxResetPartnersList } from "pages/user/store/UserR";
import { AlarmButtonGroup } from "./AlarmtalkPopup";
import { useAlert, useIConPopup } from "../popupHook";
import useLoading from "commons/loading/store/loadingHook";
import { ButtonState } from "commons/popup/store/absPopupVo";
import { useClosePopup } from "commons/popup/store/absPopupHook";
import { apiPsendAlarm } from "pages/calculate/store/CalculateR";

export const useAlarmtalkPopup = () => {
  const dispatch = useDispatch();
  const showAlarmtalkPopup = async (type: string, tab?: string) => {
    const title = type === "REVENUE" ? "매출정산" : "공지사항";
    dispatch(
      rdxPopupOpen({
        type: PopupType.ALARM_TALK_POPUP,
        width: 400,
        data: { template: type, list_type: tab },
        isClose: true,
        title: title,
        buttonWrapper: AlarmButtonGroup,
      }),
    );
  };
  return { showAlarmtalkPopup };
};

export function useAlarmPartnersListInit(data: IAlarmtalkPopUpData) {
  const { apiResult } = useApi();
  const dispatch = useDispatch();

  const { partnerList } = useSelectorEq((state: IState) => ({
    partnerList: state.userManage.partnerList,
  }));

  const listLoad = async () => {
    if (data.list_type) {
      const type = String(data.list_type).toLowerCase();
      await apiResult(apiGPartnerList, { type: type, filter: true });
    }
  };

  useEffect(() => {
    listLoad();
    return () => {
      dispatch(rdxResetPartnersList());
    };
  }, [data.list_type]);

  return { partnerList };
}

/**
 * 알림톡 보내기 기능
 */
export function useAlarmSendOut(data?: IAlarmtalkPopUpData) {
  const { on, off } = useLoading();
  const { apiResult } = useApi();
  const alert = useAlert();
  const { close } = useClosePopup(PopupType.ALARM_TALK_POPUP);
  const iconPopup = useIConPopup();

  const type = data && data.list_type ? data.list_type : "CP";
  const { checkbox } = useSelectorEq((state: IState) => ({
    checkbox: state.ui.checkBox !== undefined && state.ui.checkBox?.[`${type}_alarmtalk`],
  }));
  const checkList: string[] = [];

  if (checkbox) {
    for (const [key, value] of Object.entries(checkbox)) {
      if (value) {
        checkList.push(key);
      }
    }
  }

  const sendOut = async () => {
    if (checkList.length <= 0) {
      alert("알림톡을 발송할 사이트를 체크해주세요.");
      return;
    }
    try {
      on();
      const res = await apiResult(apiPsendAlarm, {
        template: data!.template,
        list_type: data!.list_type,
        code_list: checkList,
      });

      if (res && res.code === 200) {
        close(ButtonState.OK);
        off();
        iconPopup(
          "alert",
          {
            iconColor: "ddff3d",
            iconType: "Check",
            title: "알림톡이 발송되었습니다.",
          },
          undefined,
          // v => {
          //   v && v > 0 && loadList(false);
          // },
        );
      } else {
        close(ButtonState.OK);
        off();
        iconPopup("alert", {
          iconColor: "c81212",
          iconType: "Closed",
          title: "오류가 발생했습니다.\n관리자에게 문의주세요.",
        });
      }
    } catch (err) {
      off();
      throw new Error("API Error: apiPsendAlarm");
    }
  };
  return { sendOut };
}
